const styles = theme => ({

    subGrid:{
        width:'100%', 
        display:'flex !important', 
        justifyContent:'flex-end !important'
    },

    button:{
        width: "90px !important",
        height:'40px !important',
        fontFamily: "cardiuma-M !important",
        fontSize: "12px !important",
        padding:'8px 10px 8px 10px !important',
        backgroundColor:'#f44748 !important',
        color: "#ffffff !important",
    },

    horizantalTablayout: {
        borderRadius: '15px !important',
        background: '#131E2E ! important',
    },

    customDataGrid: {
        '& .MuiDataGrid-columnHeaders': {
            color: '#747474 !important',
            fontFamily: 'cardiuma-M ! important',
            fontSize: '13px ! important',
            fontWeight: '600 ! important',
            lineHeight: '18px ! important',
            borderRadius: '15px !important',

        },

        '& .MuiDataGrid-cell': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '12px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
            borderBottom: '1.5px solid black ! important',
        },

        "& .MuiDataGrid-menuIconButton": {
            opacity: 1,
            color: "#fff ! important"
        },

        "& .MuiDataGrid-sortIcon": {
            opacity: 1,
            color: "#fff ! important",
        },

        '& .MuiDataGrid-withBorderColor': {
            borderColor: "none !important"
        },
        
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '13px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
        },

        '& .MuiSelect-icon': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-footerContainer': {
            border: 'none ! important',
        },

        '& .MuiDataGrid-overlay': {
            backgroundColor: '#131E2E ! important',
            color: '#ffffff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '14px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
        },

        '& .MuiDataGrid-filterIcon': {
            color: '#fff ! important',
        }
    },
})

export default styles